import { Routes, Route } from "react-router-dom"
import About from "./components/About"
import Projects from "./components/Projects"
import CV from "./components/CV"
import { Navigate, useLocation } from "react-router-dom"
import NEAProject from "./components/NEAProject"
import FoodBlogProject from "./components/FoodBlogProject"
import "./App.css"
import Navbar from "./components/Navbar"
import Support from "./components/Support"
import PrivacyPolicy from "./components/PrivacyPolicy"

const App = () => {
  let location = useLocation()
  console.log(
    "link hover-underline-animation " +
      (location.pathname === "/projects" ? "active" : "")
  )

  return (
    <div style={{ padding: "30px" }}>
      <h1 className="display-3 text-center">George Garman</h1>

      <Navbar />
      
      <Routes>
      <Route path="/" element={<Navigate to="/about" />} />
      <Route path="/about" element={<About />} />
    
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/nea" element={<NEAProject />} />
      <Route path="/projects/food-blog" element={<FoodBlogProject />} />
    
      <Route path="/cv" element={<CV />} />
      <Route path="/support" element={<Support />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      
    </div>
  )
}

export default App
